'use client';

import { useFormik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import * as yup from 'yup';

import { Button } from '@/shared/ui/atoms/button';
import { Input } from '@/shared/ui/atoms/input/ui';


import styles from './ui.module.scss';

const SignUp = observer(() => {
  const router = useRouter();
  const [guids, setGuids] = useState<string[]>([]);

  const validationSchema = yup.object({
    email: yup.string().email('Неверный email').required('Обязательное поле'),
    username: yup.string().required('Обязательное поле'),
    steamUUID: yup.string().min(17, 'Steam ID должен содержать 17 символов').test('is-unique', 'Steam ID уже занят', (value) => !guids.includes(value ?? '')).required('Обязательное поле'),
    password: yup.string().required('Обязательное поле'),
    rePassword: yup
      .string()
      .required('Обязательное поле')
      .oneOf([yup.ref('password'), 'Пароли должны совпадать'], 'Пароли должны совпадать'),
  });

  const formik = useFormik({

    initialValues: {
      email: '',
      username: '',
      steamUUID: '',
      password: '',
      rePassword: '',
    },
    onSubmit: async (values) => {
      try {
        const res = await fetch('/api/users', {
          method: 'POST',
          body: JSON.stringify({
            email: values.email,
            username: values.username,
            steamUUID: values.steamUUID,
            password: values.password,
          }),

          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!res.ok) return;

        router.push('/auth/sign-in');
      } catch (error: any) {
        formik.setErrors({
          rePassword: error?.response?.data?.message ?? 'Unknown error',
        });
      }
    },
    validateOnChange: true,
    enableReinitialize: true,
    validationSchema,
  });

  useEffect(() => {
    fetch('/api/guid')
      .then(res => res.json())
      .then((data: string[]) => {
        setGuids(data.map(item => item.split('|')[1]));
      });
  }, []);

  return (
    <form className={styles.form} onSubmit={formik.handleSubmit}>
      <h2>Регистрация</h2>
      <Input
        id="email"
        type="email"
        placeholder="Email"
        value={formik.values.email}
        autoComplete='off'
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.email ? formik.errors.email : ''}
      />
      <Input
        id="username"
        type="text"
        placeholder="Никнейм"
        autoComplete='off'
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.username}
        error={formik.touched.username ? formik.errors.username : ''}
      />

      <Input
        id="steamUUID"
        type="text"
        placeholder="Steam ID"
        autoComplete='off'
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.steamUUID}
        error={formik.touched.steamUUID ? formik.errors.steamUUID : ''}
      />

      <Input
        id="password"
        type="password"
        placeholder="Пароль"
        autoComplete='off'
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.password}
        error={formik.touched.password ? formik.errors.password : ''}
      />
      <Input
        id="rePassword"
        type="password"
        autoComplete='off'
        placeholder="Повторите пароль"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.rePassword}
        error={formik.touched.rePassword ? formik.errors.rePassword : ''}
      />
      <Button type="submit" disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}>Зарегистрироваться</Button>
    </form>
  );
});

export default SignUp;
